<template>
  <va-card stripe="primary">
    <component :is="'style'">
      :root {
      --content-bg: {{ content.style.backgroundColor }};
      }
    </component>
    <SwappingSquaresSpinner v-if="loadingHandle"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div class="va-card__body" v-if="!loadingHandle">
      <form style="margin-top: 20px;">
        <div class="row">
          <va-input
            v-model="content.name"
            type="text"
            :label="$t('content.labelName')"
            class="flex xs12"
            :error="!!contentNameErrors.length"
            :error-messages="contentNameErrors"
          />
        </div>
        <div class="row" style="padding-left: 10px; margin-bottom: 10px;">
          <fieldset class="xs12" style="width: 100%;">
            <va-toggle
              v-model="content.isGlobal"
              :label="$t('content.labelGlobal')"
            />
          </fieldset>
        </div>
        <div class="row">
          <div class="flex xs12">
            <va-select
              :disabled="locations.length < 1 || content.isGlobal"
              :label="content.isGlobal ? $t('content.selectLocations') : $t('content.selectLocationsRequired')"
              v-model="selectedLocations"
              :placeholder="locations.length < 1 ? $t('content.noLocation') : $t('content.multipleLocationSelect')"
              multiple
              searchable
              textBy="name"
              keyBy="eventId"
              :options="locations"
              :error="!!locationErrors.length"
            />
          </div>
        </div>
        <div class="row" v-if="content.repeater.length > 0">
          <div class="flex xs12">
            <h4 class="label-style">{{ $t('content.labelStyle') </h4>
            <vue-repeater v-model="content.repeater"></vue-repeater>
          </div>
        </div>
        <div class="row" style="padding-left: 10px; margin-bottom: 10px;">
          <div class="flex mb3">
            <fieldset class="xs12">
              <va-toggle
                v-model="content.isFrontPage"
                :label="$t('content.labelFrontPage')"
              />
            </fieldset>
          </div>
          <div class="flex mb3">
            <fieldset class="xs12">
              <va-toggle
                v-model="content.isTop"
                :label="$t('content.labelTop')"
              />
            </fieldset>
          </div>
          <div class="flex mb3">
            <fieldset class="xs12">
              <va-toggle
                v-model="content.isActive"
                :label="$t('content.labelActive')"
              />
            </fieldset>
          </div>
        </div>
        <h3 @click="toggleContent" class="toggle-content">{{ $t('content.setContentStyles') }}</h3>
        <transition name="slide">
          <div v-if="showContent" class="row content-styles" style="padding-left: 10px; margin-bottom: 10px;">
            <div class="flex xs4">
              <h4 class="label-style">{{ $t('content.bgColor') }}</h4>
              <va-advanced-color-picker
                v-model="content.style.backgroundColor"
              />
            </div>
            <div class="flex xs4">
              <h4 class="label-style">{{ $t('content.linkColor') }}</h4>
              <va-advanced-color-picker
                v-model="content.style.linkColor"
              />
            </div>
            <div class="flex xs4">
              <h4 class="label-style">{{ $t('content.linkHoverColor') }}</h4>
              <va-advanced-color-picker
                v-model="content.style.linkColorHover"
              />
            </div>
            <va-input
              v-model="content.style.border"
              type="text"
              :label="$t('content.labelBorder')"
              class="flex xs12"
              :messages="contentStyleBorderMessages"
            />
            <va-input
              v-model="content.style.borderRadius"
              type="text"
              :label="$t('content.labelBorderRadius')"
              class="flex xs12"
              :messages="contentStyleBorderRadiusMessages"
              :error="!!contentStyleBorderRadiusErrors.length"
              :error-messages="contentStyleBorderRadiusErrors"
            />
            <va-input
              v-model="content.style.padding"
              type="text"
              :label="$t('content.labelPadding')"
              class="flex xs12"
              :messages="contentStylePaddingMessages"
              :error="!!contentStylePaddingErrors.length"
              :error-messages="contentStylePaddingErrors"
            />
            <va-input
              v-model="content.style.margin"
              type="text"
              :label="$t('content.labelMargin')"
              class="flex xs12"
              :messages="contentStyleMarginMessages"
              :error="!!contentStyleMarginErrors.length"
              :error-messages="contentStyleMarginErrors"
            />
          </div>
        </transition>
        <div class="d-flex justify--center mt-3">
          <va-button @click.prevent="onsubmit()" class="my-0">{{ $t('content.btnUpdate') }}</va-button>
        </div>
      </form>
    </div>
  </va-card>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import VueRepeater from 'vue-repeater'
import 'vue-repeater/dist/lib/vue-repeater.css'
import WysiwygEditor from '@/components/content/WysiwygEditor.vue'
import Vue from 'vue'
Vue.component('wysiwyg-editor', WysiwygEditor)
export default {
  name: 'UpdateContent',
  components: { SwappingSquaresSpinner, VueRepeater },
  mixins: [errorHandlerMixin],
  data () {
    return {
      content: {
        name: '',
        isGlobal: true,
        eventIds: [],
        repeater: [],
        isFrontPage: false,
        isActive: true,
        isTop: false,
        style: {
          backgroundColor: '#B2B2B2',
          border: '0px solid #FFFFFF',
          borderRadius: '3 3 3 3',
          padding: '16 10 16 10',
          margin: '20 0 0 0',
          linkColor: '#007bff',
          linkColorHover: '#0056b3',
        },
      },
      locations: [],
      selectedLocations: [],
      contentNameErrors: [],
      locationErrors: [],
      loadingHandle: true,
      meta: null,
      showContent: false,
      contentStyleBorderMessages: [this.$t('content.styleBorderMsg')],
      contentStyleBorderRadiusErrors: [],
      contentStyleBorderRadiusMessages: [this.$t('content.styleBorderRadiusMsg')],
      contentStylePaddingErrors: [],
      contentStylePaddingMessages: [this.$t('content.stylePaddingMsg')],
      contentStyleMarginErrors: [],
      contentStyleMarginMessages: [this.$t('content.styleMarginMsg')],
    }
  },
  methods: {
    async parseContent () {
      const content = {
        appContentId: this.$route.params.appContentId,
        title: this.content.name,
        type: 'post',
        value: '',
        isGlobal: this.content.isGlobal,
        eventIds: [],
        isFrontPage: this.content.isFrontPage,
        isActive: this.content.isActive,
        isTop: this.content.isTop,
        style: {
          backgroundColor: this.content.style.backgroundColor,
          border: this.content.style.border,
          linkColor: this.content.style.linkColor,
          linkColorHover: this.content.style.linkColorHover,
        },
      }
      this.selectedLocations.forEach(item => {
        content.eventIds.push(item.eventId)
      })
      const repeater = this.content.repeater
      const transformedArray = repeater.map((item, index) => {
        return {
          order: index,
          value: item.value.welcomeMessage,
        }
      })
      content.meta = JSON.stringify(transformedArray)

      // styles
      try {
        content.style.borderRadius = this.convertToPixels(this.content.style.borderRadius)
        this.contentStyleBorderRadiusErrors = []
      } catch (error) {
        this.contentStyleBorderRadiusErrors = [error.message]
      }

      try {
        content.style.padding = this.convertToPixels(this.content.style.padding)
        this.contentStylePaddingErrors = []
      } catch (error) {
        this.contentStylePaddingErrors = [error.message]
      }

      try {
        content.style.margin = this.convertToPixels(this.content.style.margin)
        this.contentStyleMarginErrors = []
      } catch (error) {
        this.contentStyleMarginErrors = [error.message]
      }
      return content
    },
    async onsubmit () {
      this.contentNameErrors = this.content.name ? [] : [this.$t('content.nameError')]
      if (!this.content.isGlobal) {
        this.locationErrors = this.selectedLocations.length ? [] : [this.$t('content.locationError')]
      }
      if (!this.formContentReady) {
        return
      }
      const content = await this.parseContent()
      if (!content) {
        return
      }
      this.loadingHandle = true
      this.$store.dispatch('updateContent', content)
        .then(() => {
          this.loadingHandle = false
        })
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async initContent (content) {
      content.eventIds.forEach(item => {
        this.locations.filter(loc => {
          if (loc.eventId === item) {
            const location = {
              eventId: loc.eventId,
              name: loc.name,
            }
            this.selectedLocations.push(location)
          }
        })
      })
      this.content.name = content.title
      this.content.isGlobal = content.isGlobal
      this.content.isFrontPage = content.isFrontPage
      this.content.isActive = content.isActive
      this.content.isTop = content.isTop

      const parsedMeta = JSON.parse(content.meta)
      parsedMeta.forEach((metaItem) => {
        const metaValue = metaItem.Value
        const curArr = {
          name: 'wysiwyg-editor',
          value: {
            welcomeMessage: metaValue,
          },
        }
        this.content.repeater.splice(this.content.repeater.length, 1, curArr)
      })
      if (content.style) {
        this.content.style.backgroundColor = content.style.backgroundColor
        this.content.style.border = content.style.border
        if (content.style.borderRadius) {
          this.content.style.borderRadius = this.removePx(content.style.borderRadius)
        }
        this.content.style.padding = this.removePx(content.style.padding)
        this.content.style.margin = this.removePx(content.style.margin)
        this.content.style.linkColor = content.style.linkColor
        if (content.style.linkColorHover) {
          this.content.style.linkColorHover = content.style.linkColorHover
        }
      }
    },
    async getLocations () {
      await this.$store.dispatch('getLocations')
        .then(() => this.initLocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    initLocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
      this.loadingHandle = false
    },
    convertToPixels (values) {
      const match = values.match(/^(\d+)\s+(\d+)\s+(\d+)\s+(\d+)$/)

      if (match) {
        return `${match[1]}px ${match[2]}px ${match[3]}px ${match[4]}px`
      } else {
        throw new Error(this.$t('content.convertError'))
      }
    },
    removePx (values) {
      const match = values.match(/^(\d+px)\s+(\d+px)\s+(\d+px)\s+(\d+px)$/)
      if (match) {
        return `${match[1].replace('px', '')} ${match[2].replace('px', '')} ${match[3].replace('px', '')} ${match[4].replace('px', '')}`
      }
    },
    toggleContent () {
      this.showContent = !this.showContent
    },
  },
  computed: {
    formContentReady () {
      return !(this.contentNameErrors.length || this.locationErrors.length)
    },
  },
  mounted () {
    this.getLocations()
      .then(() => this.$store.dispatch('getContentByAppContentId', this.$route.params.appContentId))
      .then((resp) => this.initContent(resp.data.message))
      .catch(error => {
        this.errorHandler(error.response)
        this.loadingHandle = false
      })
  },
  updated () {
    // Set type button to resolve issue with page reload
    const repeater = document.querySelector('.repeater')
    if (repeater) {
      const buttons = repeater.querySelectorAll('button')
      buttons.forEach((button) => {
        const buttonTitle = button.getAttribute('title')
        if (buttonTitle === 'Add') {
          button.remove()
        }
        button.setAttribute('type', 'button')
      })
    }
    const repeaterBlocks = document.querySelectorAll('.repeater-block')
    repeaterBlocks.forEach((block) => {
      block.setAttribute('draggable', 'false')
    })
  },
}
</script>

<style lang="scss" scoped>
.content-styles {
  .va-color-input {
    display: block;

    &__input {
      width: 100%;
      margin-bottom: 0;
      margin-left: 0.25rem;
      min-width: 5.6rem;
    }
  }
}

.toggle-content {
  margin: 25px 0;

  &:hover {
    cursor: pointer;
  }
}

.label-style {
  margin-bottom: 0.5rem;
  max-width: calc(100% - 0.25rem);
  font-size: 0.625rem;
  letter-spacing: 0.0375rem;
  line-height: 1.2;
  font-weight: bold;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  color: rgb(108, 127, 238);
}

form {
  overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>

<style>
.ck.ck-editor__main > .ck-editor__editable {
  background: var(--content-bg);
}
</style>
